import './_jquery';
import 'waypoints/lib/jquery.waypoints.js';
import MobileDetect from 'mobile-detect';
const md = new MobileDetect(window.navigator.userAgent);

// this is for mail cta init and reset top position when is
// not fixed.

const startPosition = function() {
  let $anchor, $breadcrumb, $menu, anchor_height, anchor_top, breadcrumb_height, breadcrumb_top, menu_height, menu_top;

  $menu = $('.site-header');

  if ($menu.length > 0) {
    menu_height = $menu.outerHeight();
    menu_top = $menu.position()['top'];
    return menu_top + menu_height;
  } else if ($('.breadcrumb--fixed').length > 0) {
    $breadcrumb = $('.breadcrumb--fixed');
    breadcrumb_height = $breadcrumb.outerHeight();
    breadcrumb_top = $breadcrumb.position()['top'];
    return breadcrumb_top + breadcrumb_height;
  } else if ($('.component-anchor-nav--fixed').length > 0) {
    $anchor = $('.component-anchor-nav--fixed');
    anchor_height = $banchor.outerHeight();
    anchor_top = $anchor.position()['top'];
    return anchor_top + anchor_height;
  } else {
    return 0;
  }
};

const calcPosition = function() {
  let anchorbarHeight, breadcrumbHeight, distance, menuHeight;

  distance = initialHeaderHeight;
  menuHeight = $('.site-header__components--fixed').outerHeight();
  breadcrumbHeight = $('.breadcrumb--fixed').outerHeight();
  anchorbarHeight = $('.component-anchor-nav--fixed').outerHeight();

  if ($.isNumeric(menuHeight)) { distance = menuHeight; }
  if ($.isNumeric(breadcrumbHeight)) { distance = distance + breadcrumbHeight; }
  if ($.isNumeric(anchorbarHeight)) { distance = distance + anchorbarHeight; }
  if (!$.isNumeric(breadcrumbHeight) && !$.isNumeric(anchorbarHeight)) { distance = initialHeaderHeight; }

  return distance;
};

// Fix menu when scroll
const fixerMenu = function(status) {
  let headerHeight, isHome, isHomeWithHeaderVariation, isPreview, urlParams;

  urlParams = new URLSearchParams(window.location.search);
  isPreview = urlParams.get('preview');
  isHome = window.location.pathname === '/' && null === isPreview ? true : false;

  isHomeWithHeaderVariation = function() {
    if (!isHome) { return false; }

    if ($('.home__header').hasClass('home__header--01a')) { return true; }
    if ($('.home__header').hasClass('home__header--01b')) { return true; }
    if ($('.home__header').hasClass('home__header--02')) { return true; }

    return false;
  };

  headerHeight = $('.site-header').height();

  $('.site-header').attr('style', 'min-height: ' + headerHeight + 'px');

  if (status === 'fix') {
    if (isHomeWithHeaderVariation()) {
      $('[data-logo-white]').css('display', 'none');
      $('[data-logo-black]').css('display', 'block');
    } else if (isHome && $('.site-header').hasClass('site-header--home')) {
      $('.site-header').removeClass('site-header--home');
      $('[data-logo-white]').css('display', 'none');
      $('[data-logo-black]').css('display', 'block');
    } else {
      $('[data-logo-white]').css('display', 'none');
      $('[data-logo-black]').css('display', 'block');
    }
    $('.site-header__components').addClass('site-header__components--fixed');
  }

  if (status === 'unfix') {
    if (isHomeWithHeaderVariation()) {
      $('[data-logo-white]').css('display', 'none');
      $('[data-logo-black]').css('display', 'block');
      if (!md.mobile()) {
        $('.top_menu .menu-item img').css('filter', 'invert(100%)');
      }
    } else if (isHome && !$('.site-header').hasClass('site-header--home')) {
      $('.site-header').addClass('site-header--home');
      $('[data-logo-white]').css('display', 'block');
      $('[data-logo-black]').css('display', 'none');
    } else if (isHome) {
      $('[data-logo-white]').css('display', 'block');
      $('[data-logo-black]').css('display', 'none');
    } else {
      $('[data-logo-white]').css('display', 'none');
      $('[data-logo-black]').css('display', 'block');
    }
    $('.site-header__components').removeClass('site-header__components--fixed');
  }

  if (typeof Waypoint !== "undefined" && Waypoint !== null) {
    Waypoint.refreshAll()
  }
};

const initialHeaderHeight = startPosition();
const mobileAdditionalSpace = md.mobile() ? 20 : 0;

jQuery(function() {
  $('.site-content__right_side_cta').css('top', initialHeaderHeight + mobileAdditionalSpace);
});

$(window).on('resize', function() {
  $('.site-content__right_side_cta').css('top', calcPosition() + mobileAdditionalSpace);
});

$(window).on('scroll', function() {
  if ($(window).scrollTop() < 50) {
    $('.site-content__right_side_cta').css('top', initialHeaderHeight + mobileAdditionalSpace);
  }
  $('.site-content__right_side_cta').css('top', calcPosition() + mobileAdditionalSpace);
});

// MAIN-MENU
jQuery(function() {
  let classToOpenElement, classToOpenFirstElement, headerHeight, prevScroll, scroll;

  classToOpenElement = 'menu-item--opened';
  classToOpenFirstElement = 'menu-item--opened-first';

  prevScroll = $(window).scrollTop();
  scroll = $(window).scrollTop();

  $(document).ready(function() {
    if (window.pageYOffset > 26) {
      fixerMenu('fix');
    } else {
      fixerMenu('unfix');
    }
  });

  $(window).scroll(function() {
    prevScroll = scroll;
    scroll = $(window).scrollTop();
    if (scroll > prevScroll && (scroll > 26 && prevScroll <= 26)) {
      fixerMenu('fix');
    }
    if (scroll < prevScroll && (scroll <= 26 && prevScroll > 26)) {
      return fixerMenu('unfix');
    }
  });

  if (!md.mobile()) {
    $('.main_menu > .menu-item.with-submenu').hover(function() {
      let elements, firstElement;
      elements = $(this).children('.main_menu__submenu').children('.menu-item');
      firstElement = elements.first();
      elements.removeClass(classToOpenElement);
      if (!firstElement.hasClass(classToOpenFirstElement)) {
        firstElement.addClass(classToOpenFirstElement);
      }
    });

    $('.main_menu__submenu > .menu-item').hover(function() {
      if (!$(this).hasClass(classToOpenElement)) {
        $(this).siblings().removeClass(classToOpenElement);
        $(this).siblings().removeClass(classToOpenFirstElement);
        $(this).addClass(classToOpenElement);
      }
    });

    $('.component-menu').each(function() {
      let redSide, redSideHeight, whiteSideHeight;
      whiteSideHeight = $(this).innerHeight();
      redSide = $(this).parent('.menu-item').parent('.main_menu__submenu');
      redSideHeight = redSide.innerHeight();
      if (redSideHeight < whiteSideHeight) {
        redSide.height(whiteSideHeight + 5);
      }
    });

    $("[data-menu-element='submenu_list_link']").hover(function() {
      $(this).siblings('[data-menu-element]').toggleClass('animate--opacity-30');
    });
  }

  // Mobile Menu - navigation
  if (md.mobile()) {
    headerHeight = $('.site-header').outerHeight();
    $('.site-header__menu--mobile').css({ 'top': headerHeight });
        $('.menu--mobile__external-wrapper').css({ 'top': headerHeight });

    $('.site-header__menu--mobile .with-submenu').on('click', function() {
      $('.main_menu__submenu', this).css({
        'top': headerHeight,
        'visibility': 'visible',
        'opacity': 1,
        'pointer-events': 'auto'
      });
    });

    // Open component-mobile
    $('.site-header__menu--mobile .main_menu__submenu >.menu-item').on('click', function() {
      let that;

      that = $('.component-menu--mobile', this).clone();
      $('.menu--mobile__external-wrapper').append(that);
      $('.menu--mobile__external-wrapper').show();
      $('.menu--mobile__external-wrapper >.component-menu--mobile').show();
    });

    $('.site-header__menu-button__hamburger').on('click', function() {
      $('.menu--mobile__external-wrapper').hide();
      $('.menu--mobile__external-wrapper >.component-menu--mobile').remove();
      $('.main_menu__submenu').each(function() {
        $(this).css({
          'visibility': 'hidden',
          'opacity': 0
        });
      });
    });

    $('.menu_back_button').on('click', function(ev) {
      let elementClass;

      elementClass = '.' + $(this).data('submenu-close');
      $('.menu--mobile__external-wrapper').hide();
      $('.menu--mobile__external-wrapper >.component-menu--mobile').remove();

      if ('.main_menu__submenu' === elementClass) {
        $(this).parent(elementClass).removeAttr('style');
      }

      ev.stopPropagation();
    });
  }
});
